import React from "react";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const RoleManagementCreate = () => {
  // Fetch stored role data
  const roleData = getStoredData()?.[1] || {}; // Ensure roleData is an object

  return (
    <div>
      <h2>Create New {roleData.TitleRole}</h2>
      <DynamicForm
        fields={roleData.AdminRole} // Pass dynamic fields
        apiUrl={roleData.ApiRole} // Use correct API URL
        successRedirect={roleData.RedirectAdminRole} // Redirect after successful submission
      />
    </div>
  );
};

export default RoleManagementCreate;
